import validate from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import old_45admin_45auth_45global from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/middleware/OLD-admin-auth.global.ts";
import auth_45global from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/middleware/auth.global.ts";
import new_45quotation_45reset_45global from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/middleware/new-quotation-reset.global.ts";
import quotation_45hydrate_45global from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/middleware/quotation-hydrate.global.ts";
import manifest_45route_45rule from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  old_45admin_45auth_45global,
  auth_45global,
  new_45quotation_45reset_45global,
  quotation_45hydrate_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}